// --- Scroll infinito carousel ---
(function() {
function initCarouselLoop() {
document.querySelectorAll('scroll-carousel.product-gallery__carousel').forEach(carousel => {
if (carousel.dataset.loopInit) return;
carousel.dataset.loopInit = 'true';

const getItems = () => Array.from(carousel.querySelectorAll('.product-gallery__media'));
const getCurrentIndex = () => Math.round(carousel.scrollLeft / carousel.offsetWidth);
const goTo = (index) => {
carousel.scrollTo({ left: index * carousel.offsetWidth, behavior: 'smooth' });
};

const wrapper = carousel.closest('.product-gallery__carousel-with-arrows');
if (wrapper) {
const prevBtn = wrapper.querySelector('carousel-prev-button button');
const nextBtn = wrapper.querySelector('carousel-next-button button');

if (prevBtn) {
prevBtn.addEventListener('click', (e) => {
const items = getItems();
const current = getCurrentIndex();
if (current === 0) {
e.stopImmediatePropagation();
prevBtn.disabled = false;
goTo(items.length - 1);
}
}, true);
}

if (nextBtn) {
nextBtn.addEventListener('click', (e) => {
const items = getItems();
const current = getCurrentIndex();
if (current === items.length - 1) {
e.stopImmediatePropagation();
nextBtn.disabled = false;
goTo(0);
}
}, true);
}

carousel.addEventListener('scroll', () => {
if (prevBtn) prevBtn.disabled = false;
if (nextBtn) nextBtn.disabled = false;
}, { passive: true });
}

let touchStartX = 0;
let isAnimating = false;

carousel.addEventListener('touchstart', (e) => {
touchStartX = e.touches[0].clientX;
}, { passive: true });

carousel.addEventListener('touchend', (e) => {
if (isAnimating) return;
const deltaX = touchStartX - e.changedTouches[0].clientX;
const items = getItems();
if (items.length <= 1) return;
const current = getCurrentIndex();
if (deltaX > 30 && current === items.length - 1) {
isAnimating = true;
goTo(0);
setTimeout(() => { isAnimating = false; }, 500);
} else if (deltaX < -30 && current === 0) {
isAnimating = true;
goTo(items.length - 1);
setTimeout(() => { isAnimating = false; }, 500);
}
}, { passive: true });
});
}

const observer = new MutationObserver(() => {
if (document.querySelector('scroll-carousel.product-gallery__carousel')) {
initCarouselLoop();
}
});
observer.observe(document.body, { childList: true, subtree: true });

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initCarouselLoop);
} else {
initCarouselLoop();
}

document.addEventListener('shopify:section:load', initCarouselLoop);
document.addEventListener('click', (e) => {
if (e.target.closest('.product-card__quick-add-button')) {
setTimeout(initCarouselLoop, 300);
setTimeout(initCarouselLoop, 700);
}
});
})();



// --- Cart Drawer: aggiunge icona SVG al pulsante "nota" ---
(function () {

function addIcon(btn) {
if (btn.dataset.iconAdded) return;
btn.dataset.iconAdded = "true";

btn.style.display = "flex";
btn.style.alignItems = "center";
btn.style.gap = "6px";

const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
svg.setAttribute("viewBox", "0 0 24 24");
svg.setAttribute("width", "16");
svg.setAttribute("fill", "none");
svg.setAttribute("stroke-width", "1.5");

svg.innerHTML = `
<path d="M21.75 18.75h-10.5l-6 4.5v-4.5h-3a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.25 7.5h13.5M5.25 12h10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
`;

btn.prepend(svg);
}

function scan(drawer) {
drawer.querySelectorAll("button.link-faded-reverse").forEach(btn => {
if (btn.textContent.includes("nota")) addIcon(btn);
});
}

function init() {
const drawer = document.querySelector("cart-drawer");
if (!drawer) return;

scan(drawer);

new MutationObserver(() => scan(drawer))
.observe(drawer, { childList: true, subtree: true });
}

new MutationObserver(init).observe(document.body, { childList: true, subtree: true });

init();
})();

// --- Cart Drawer: sostituisce submit nativo con pulsante "Applica" custom ---
(function () {

function initDiscountButton() {
const discountField = document.querySelector('cart-discount-field');
if (!discountField || discountField.dataset.customButtonInit) return;

const input = discountField.querySelector('input:not([type="hidden"])');
if (!input) return;

discountField.dataset.customButtonInit = 'true';

// Blocca l'evento change nativo per evitare doppio submit
input.addEventListener('change', (e) => {
e.stopImmediatePropagation();
}, true);

const wrapper = document.createElement('div');
wrapper.style.cssText = 'display:flex; gap:8px; align-items:center;';
input.parentNode.insertBefore(wrapper, input);
wrapper.appendChild(input);

const button = document.createElement('button');
button.type = 'button';
button.textContent = 'Applica';
button.className = 'button';
wrapper.appendChild(button);

// Chiama il metodo nativo toggleDiscount tramite prototype
button.addEventListener('click', () => {
const fakeEvent = {
currentTarget: discountField,
target: { value: input.value }
};
const instance = customElements.get('cart-discount-field');
const proto = instance.prototype._proto_;
proto.toggleDiscount.call(discountField, fakeEvent);
});

// Supporto tasto Invio sul campo input
input.addEventListener('keydown', (e) => {
if (e.key === 'Enter') {
e.preventDefault();
button.click();
}
});
}

function observeCartDrawer() {
const cartDrawer = document.querySelector('cart-drawer');
if (!cartDrawer) return;

initDiscountButton();

new MutationObserver(() => initDiscountButton())
.observe(cartDrawer, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', observeCartDrawer);
} else {
observeCartDrawer();
} })();



// --- Cart Drawer: inietta pulsante X per chiudere la nota carrello ---
document.addEventListener('DOMContentLoaded', function () {

function injectCartNoteCloseButtons() {
document.querySelectorAll('cart-note-dialog').forEach(function (dialog) {
if (dialog.querySelector('.cart-note-close-btn')) return;

const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'cart-note-close-btn';
btn.setAttribute('aria-label', 'Chiudi');
btn.innerHTML = '&times;';

// Delega il click al pulsante nativo di chiusura
btn.addEventListener('click', function () {
const nativeClose = dialog.querySelector('dialog-close-button button');
if (nativeClose) nativeClose.click();
});

const label = dialog.querySelector('label');
if (label) {
const wrapper = document.createElement('div');
wrapper.className = 'cart-note-label-row';
label.parentNode.insertBefore(wrapper, label);
wrapper.appendChild(label);
wrapper.appendChild(btn);
}
});
}

injectCartNoteCloseButtons();

new MutationObserver(injectCartNoteCloseButtons)
.observe(document.body, { childList: true, subtree: true });
});



// --- Barra spedizione gratuita: aggiorna larghezza e stile fill ---
(function () {

function updateBars() {
document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
const threshold = parseInt(bar.getAttribute('threshold')) || 0;
const total = parseInt(bar.getAttribute('total-price')) || 0;
if (threshold <= 0) return;

const percent = Math.min((total / threshold) * 100, 100);
const fill = bar.querySelector('.free-shipping-progress-fill');
if (!fill) return;

fill.style.width = percent + "%";

// Saturazione e luminosità crescono al riempimento
const saturation = 0.6 + (percent / 100) * 0.8;
const brightness = 1 + (percent / 100) * 0.12;
fill.style.filter = `saturate(${saturation}) brightness(${brightness})`;

fill.classList.toggle("is-complete", percent >= 100);
});
}

document.addEventListener("DOMContentLoaded", function () {
updateBars();
setInterval(updateBars, 600);
});
})();



// --- Barra spedizione gratuita: inietta HTML della progress bar nel componente ---
(function () {

const progressHTML = `
<div class="free-shipping-progress-wrapper">
<div class="free-shipping-progress-bar">
<div class="free-shipping-progress-fill"></div>
</div>
</div>
`;

function injectBar() {
document.querySelectorAll("free-shipping-bar").forEach(bar => {
if (bar.querySelector(".free-shipping-progress-wrapper")) return;

const span = bar.querySelector("span");
if (span) {
span.insertAdjacentHTML("afterend", progressHTML);
} else {
bar.insertAdjacentHTML("beforeend", progressHTML);
}
});
}

new MutationObserver(injectBar).observe(document.body, { childList: true, subtree: true });

injectBar();
})();



// --- Localizzazione: sostituisce testo lingua con bandiera SVG (IT/EN) ---
(function () {

  // Nasconde la bandiera nativa sul toggle paese
  const style = document.createElement('style');
  style.textContent = `
    button.localization-toggle[aria-controls*="country"] .country-flag { display: none !important; }
  `;
  document.head.appendChild(style);

  // Crea elemento <img> con bandiera in base al codice ISO
  function buildFlagImg(isoCode) {
    const isItalian = isoCode === 'it';
    const flagCode  = isItalian ? 'it' : 'gb';
    const altText   = isItalian ? 'Italia' : 'Regno Unito';
    const src = '//cdn.shopify.com/static/images/flags/' + flagCode + '.svg?format=jpg&width=60';

    const img = document.createElement('img');
    img.src       = src;
    img.alt       = altText;
    img.setAttribute('srcset', src + ' 60w');
    img.width     = 60;
    img.height    = 45;
    img.loading   = 'lazy';
    img.className = 'country-flag';
    return img;
  }

  // Applica bandiera al pulsante toggle lingua (es. header)
  function processToggleButton(btn) {
    if (btn._localeFlagApplied) return;
    const popoverId = btn.getAttribute('aria-controls');
    if (!popoverId || !popoverId.includes('locale')) return;

    const popover = document.getElementById(popoverId);
    if (!popover) return;

    const selectedOption = popover.querySelector('[aria-selected="true"]');
    if (!selectedOption) return;

    const isoCode = selectedOption.getAttribute('value');
    if (!isoCode) return;

    const chevron = btn.querySelector('svg, .icon');
    btn.innerHTML = '';
    btn.appendChild(buildFlagImg(isoCode));
    btn.appendChild(document.createTextNode(' ' + isoCode));
    if (chevron) btn.appendChild(chevron);

    btn._localeFlagApplied = true;
  }

  // Applica bandiera alle singole opzioni nel popover
  function processLocaleOption(btn) {
    if (btn._localeFlagApplied) return;
    const isoCode = btn.getAttribute('value');
    if (!isoCode) return;

    btn.innerHTML = '';
    btn.appendChild(buildFlagImg(isoCode));
    btn.appendChild(document.createTextNode(' ' + isoCode));

    btn._localeFlagApplied = true;
  }

  function applyAll() {
    document.querySelectorAll('button.localization-toggle[aria-controls*="locale"]').forEach(processToggleButton);
    document.querySelectorAll('button[name="locale_code"]').forEach(processLocaleOption);
  }

  applyAll();

  // Osserva DOM per elementi aggiunti dinamicamente
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches('button.localization-toggle')) processToggleButton(node);
        if (node.matches('button[name="locale_code"]'))  processLocaleOption(node);

        node.querySelectorAll('button.localization-toggle').forEach(processToggleButton);
        node.querySelectorAll('button[name="locale_code"]').forEach(processLocaleOption);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

})();




// --- Guida alle taglie: modal globale con blocco chiusura quick buy ---
(function () {
  window._sizeGuideOpen = false;

  // Patcha il metodo hide() di quick-buy-modal per non chiuderlo mentre la guida è aperta
  function patchQuickBuyModalProto() {
    var qbm = document.querySelector('quick-buy-modal');
    if (!qbm) return;
    var proto = Object.getPrototypeOf(qbm);
    if (proto._hidePatched) return;
    var _origHide = proto.hide;
    proto.hide = function () {
      if (window._sizeGuideOpen) return;
      return _origHide.apply(this, arguments);
    };
    proto._hidePatched = true;
  }

  function closeSizeGuide(modal) {
    modal.style.display = 'none';
    window._sizeGuideOpen = false;
    document.body.classList.remove('no-scroll');
  }

  var globalModal = null;

  // Crea il modal una sola volta e lo riusa
  function getOrCreateGlobalModal() {
    if (globalModal && document.body.contains(globalModal)) return globalModal;

    globalModal = document.createElement('div');
    globalModal.className = 'size-guide-modal';
    globalModal.innerHTML = `
      <div class="size-guide-modal__content">
        <div class="size-guide-modal__close-wrapper">
          <button type="button" class="size-guide-close">×</button>
        </div>
        <div class="size-guide-modal__image">
          <img src="" alt="size-guide">
        </div>
      </div>
    `;
    document.body.appendChild(globalModal);

    var closeBtn = globalModal.querySelector('.size-guide-close');

    // Chiusura via pulsante X (click e touch)
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      closeSizeGuide(globalModal);
    }, true);

    closeBtn.addEventListener('touchend', function (e) {
      e.stopPropagation();
      e.preventDefault();
      closeSizeGuide(globalModal);
    }, { capture: true, passive: false });

    // Chiusura cliccando fuori dal contenuto
    globalModal.addEventListener('click', function (e) {
      var content = globalModal.querySelector('.size-guide-modal__content');
      if (!content.contains(e.target)) closeSizeGuide(globalModal);
    });

    globalModal.addEventListener('touchend', function (e) {
      var content = globalModal.querySelector('.size-guide-modal__content');
      if (!content.contains(e.target)) {
        e.preventDefault();
        closeSizeGuide(globalModal);
      }
    }, { passive: false });

    return globalModal;
  }

  // Intercetta click su qualsiasi pulsante sizeGuideBtn
  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('[id^="sizeGuideBtn-"]');
    if (!btn) return;
    e.stopImmediatePropagation();

    var wrapper = btn.closest('.size-guide-wrapper');
    if (!wrapper) return;
    var sourceImg = wrapper.querySelector('.size-guide-modal__image img');

    var modal = getOrCreateGlobalModal();
    var targetImg = modal.querySelector('.size-guide-modal__image img');

    if (sourceImg) {
      targetImg.src = sourceImg.src;
      targetImg.alt = sourceImg.alt || 'size-guide';
    }

    patchQuickBuyModalProto();

    window._sizeGuideOpen = true;
    modal.style.display = 'block';
    document.body.classList.add('no-scroll');
  }, true);

})();



/* --- FitQuiz + Guida taglie: raggruppa easysize e size guide in un wrapper comune --- */
{
  function applyFitQuizLayout() {
    const container = document.querySelector('.product-info__block-list');
    if (!container) return;

    const easysize  = container.querySelector('.fq-root');
    const sizeguide = container.querySelector('[data-block-type="liquid"] .sg-trigger-btn')?.closest('.product-info__block-item');

    if (!easysize || !sizeguide) return;

    // Già wrappati correttamente → niente da fare
    const existing = easysize.closest('.fitquiz-sizeguide');
    if (existing && existing.contains(sizeguide)) return;

    // Rimuovi eventuali wrapper parziali/orfani
    container.querySelectorAll('.fitquiz-sizeguide').forEach(function (el) {
      el.replaceWith(...el.childNodes);
    });

    const wrapper = document.createElement('div');
    wrapper.classList.add('fitquiz-sizeguide');
    easysize.parentNode.insertBefore(wrapper, easysize);
    wrapper.appendChild(easysize);
    wrapper.appendChild(sizeguide);
  }

  // Esegui subito (elementi già nel DOM)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFitQuizLayout);
  } else {
    applyFitQuizLayout();
  }

  // Observer solo per navigazione SPA / re-render del tema
  let busy = false;
  const obs = new MutationObserver(function () {
    if (busy) return;
    const easysize = document.querySelector('.fq-root');
    if (!easysize) return;
    busy = true;
    applyFitQuizLayout();
    busy = false;
  });
  obs.observe(document.body, { childList: true, subtree: true });
}

// --- Forza prima immagine come predefinita nei carousel ---
(function () {
  const originalDefine = customElements.define.bind(customElements);

  customElements.define = function (name, constructor, options) {
    if (name === 'scroll-carousel') {
      const originalConnectedCallback = constructor.prototype.connectedCallback;

      constructor.prototype.connectedCallback = function () {
        if (this.classList.contains('product-gallery__carousel')) {
          const medias = Array.from(this.querySelectorAll('.product-gallery__media:not([hidden])'));

          if (medias.length > 1) {
            // Rimuove is-initial da tutti e lo assegna solo alla prima slide
            medias.forEach(m => m.classList.remove('is-initial'));
            medias[0].classList.add('is-initial');

            // Aggiorna aria-current sui bottoni di navigazione
            const firstMediaId = medias[0].getAttribute('data-media-id');
            const gallery = this.closest('product-gallery');
            if (gallery) {
              gallery.querySelectorAll('[aria-current]').forEach(btn => {
                btn.setAttribute('aria-current',
                  btn.getAttribute('data-media-id') === firstMediaId ? 'true' : 'false'
                );
              });
            }

            // Emette evento carousel:change dopo il rendering
            const carouselEl = this;
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                carouselEl.dispatchEvent(new CustomEvent('carousel:change', {
                  detail: { index: 0, cell: medias[0] }
                }));
              });
            });
          }
        }

        return originalConnectedCallback.apply(this, arguments);
      };
    }

    return originalDefine(name, constructor, options);
  };
})();



/* --- Cookie banner: inietta pulsante X ---
document.addEventListener("DOMContentLoaded", function () {

  function addCookieClose() {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner || banner.querySelector('.cookie-close-x')) return;

    const acceptBtn = document.querySelector('#shopify-pc__banner__btn-accept');
    if (!acceptBtn) return;

    const close = document.createElement("button");
    close.innerHTML = "✕";
    close.className = "cookie-close-x";

    close.addEventListener("click", function () {
      acceptBtn.click();
    });

    banner.appendChild(close);
  }

  addCookieClose();
  setTimeout(addCookieClose, 1000);
}); */



// --- Variant picker: icone SVG negli swatch slip tanga brasiliana ---
(function () {

  const VARIANT_ICONS = [
    { keywords: ['brasiliana', 'brazilian'],     url: 'https://cdn.shopify.com/s/files/1/0627/5622/5181/files/slip-brasiliana.svg' },
    { keywords: ['tanga', 'thong'],              url: 'https://cdn.shopify.com/s/files/1/0627/5622/5181/files/slip-tanga.svg' },
    { keywords: ['classic', 'classico', 'slip'], url: 'https://cdn.shopify.com/s/files/1/0627/5622/5181/files/slip-classic.svg' },
  ];

  function getIconUrl(label) {
    const lower = label.toLowerCase();
    const match = VARIANT_ICONS.find(function (item) {
      return item.keywords.some(function (kw) { return lower.includes(kw); });
    });
    return match ? match.url : null;
  }

  function injectIcons(root) {
    root.querySelectorAll('.variant-picker__option-values .block-swatch').forEach(function (swatch) {
      if (swatch.querySelector('.vp-slip-icon')) return;
      if (swatch.dataset.vpProcessed) return;

      const span = swatch.querySelector('span');
      if (!span) return;

      const label = span.textContent.trim();
      if (!label) return;

      const iconUrl = getIconUrl(label);
      if (!iconUrl) return;

      swatch.dataset.vpProcessed = 'true';

      const img = document.createElement('img');
      img.src = iconUrl;
      img.alt = label;
      img.className = 'vp-slip-icon';
      img.style.cssText = 'display:block;object-fit:contain;margin:0 auto 4px;pointer-events:none;flex-shrink:0;';

      swatch.style.cssText += ';display:flex;flex-direction:column;align-items:center;justify-content:center;';
      span.parentNode.insertBefore(img, span);
    });
  }

  function startObserver() {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('variant-picker')) {
            injectIcons(node);
          } else if (node.querySelector) {
            const picker = node.querySelector('variant-picker, .variant-picker');
            if (picker) injectIcons(node);
            else if (node.querySelector('.block-swatch')) injectIcons(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Reiniet al mount del quick buy modal
  function listenQuickBuy() {
    document.addEventListener('dialogafter-show', function (e) {
      const modal = e.target;
      if (!modal || modal.tagName.toLowerCase() !== 'quick-buy-modal') return;
      injectIcons(modal);
      setTimeout(function () { injectIcons(modal); }, 150);
    });
  }

  // Reiniet al cambio variante
  function listenRerender() {
    document.addEventListener('variant:changed', function (e) {
      const formId = e.detail && e.detail.form && e.detail.form.id;
      if (!formId) return;
      const picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
      if (picker) injectIcons(picker);
    });
  }

  function init() {
    injectIcons(document);
    startObserver();
    listenQuickBuy();
    listenRerender();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();

// --- Quick buy: nasconde selettore colore nel variant picker ---
(function () {
  const colorNames = ['colore', 'color', 'colour'];

  function processQuickBuyPicker(picker) {
    if (picker.dataset.processed) return;
    picker.dataset.processed = 'true';

    picker.querySelectorAll('fieldset.variant-picker__option').forEach(function (fs) {
      const legend = fs.querySelector('legend');
      if (!legend) return;
      const name = legend.textContent.replace(':', '').trim().toLowerCase();
      if (colorNames.includes(name)) fs.style.display = 'none';
    });
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VARIANT-PICKER' && node.getAttribute('context') === 'quick_buy') {
          processQuickBuyPicker(node);
          return;
        }
        node.querySelectorAll('variant-picker[context="quick_buy"]').forEach(processQuickBuyPicker);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

// --- MENU: forza colore e peso su voce SAND SPECIAL PRICE / SUMMER SALE

document.addEventListener("DOMContentLoaded", function () {

  const elements = document.querySelectorAll(
    'summary.header-sidebar__linklist-button, .mega-menu__linklist a.h6'
  );

  elements.forEach(function (el) {
    if (el.textContent.trim() === 'SPECIAL PROMO') {

      function applyStyle() {
        el.style.setProperty('color', '#ed313f', 'important');
        el.style.setProperty('font-weight', '700', 'important');
      }

      applyStyle();

      // Riapplica se il tema sovrascrive gli stili
      const observer = new MutationObserver(applyStyle);
      observer.observe(el, { attributes: true });
    }
  });

});

// STEFANO - RIMUOVI VARIANTE SLIP DAL TITOLO PRODOTTO
function escapeRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function cleanSlipTitle(card) {
  const titleEl = card.querySelector('.product-title');
  const slipEl = card.querySelector('.product-card__variante-slip');
  
  if (!titleEl || !slipEl) return;
  
  const slipText = slipEl.textContent.trim();
  if (!slipText) return;
  
  const regex = new RegExp(escapeRegex(slipText), 'gi');
  titleEl.textContent = titleEl.textContent.replace(regex, '').trim();
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('product-card').forEach(cleanSlipTitle);

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'PRODUCT-CARD') {
          cleanSlipTitle(node);
        }
        node.querySelectorAll?.('product-card').forEach(cleanSlipTitle);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// STEFANO - GIFT BOX MODAL FIX
document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('gift-box-quick-buy-drawer');
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
});
// STEFANO - preordine scaduto: rimuove la proprietà PRE-ORDINE dalle righe del carrello quando il preordine non è più attivo
(function () {
  var done = {};
  function cleanExpiredPreorders() {
    document.querySelectorAll('[data-expired-preorder]').forEach(function (el) {
      var key = el.getAttribute('data-expired-preorder');
      if (!key || done[key]) return;
      done[key] = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, properties: { 'PRE-ORDINE': '' } })
      }).then(function (res) {
        if (!res.ok) done[key] = false;
      }).catch(function () { done[key] = false; });
    });
  }
  document.addEventListener('DOMContentLoaded', cleanExpiredPreorders);
  new MutationObserver(cleanExpiredPreorders).observe(document.documentElement, { childList: true, subtree: true });
})();

// STEFANO - GIFT BOX: la galleria del quick buy segue la variante scelta (il tema non lo fa perché il form viene ri-renderizzato)
(function () {
  function syncGiftBoxImage() {
    var modal = document.getElementById('gift-box-quick-buy-drawer');
    if (!modal) return;
    var data = modal.querySelector('script[data-variant]');
    var carousel = modal.querySelector('scroll-carousel');
    if (!data || !carousel || typeof carousel.select !== 'function') return;
    var variant;
    try { variant = JSON.parse(data.textContent); } catch (e) { return; }
    var media = variant.featured_media || variant.featured_image;
    if (!media || !media.position) return;
    var index = media.position - 1;
    if (carousel.selectedIndex !== index && index < carousel.cells.length) {
      carousel.select(index, { instant: true });
    }
    modal.dataset.giftSyncedVariant = variant.id;
  }

  /* all'apertura del modale la galleria parte dalla prima foto: la allineo alla variante selezionata */
  function syncOnOpen() {
    var modal = document.getElementById('gift-box-quick-buy-drawer');
    var data = modal && modal.querySelector('script[data-variant]');
    if (!data) { if (modal) delete modal.dataset.giftSyncedVariant; return; }
    try {
      if (String(JSON.parse(data.textContent).id) === modal.dataset.giftSyncedVariant) return;
    } catch (e) { return; }
    syncGiftBoxImage();
  }
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('gift-box-quick-buy-drawer');
    if (modal) new MutationObserver(function () { setTimeout(syncOnOpen, 100); }).observe(modal, { childList: true, subtree: true });
  });
  document.addEventListener('product:rerender', function (event) {
    var form = event.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : '';
    if (!document.getElementById('gift-box-quick-buy-drawer')?.contains(document.querySelector('[form="' + formId + '"]'))) return;
    setTimeout(syncGiftBoxImage, 50);
    setTimeout(syncGiftBoxImage, 400);
  }, true);
})();
